import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Ruler, Bell } from 'lucide-react';

const CustomersSection: React.FC = () => {
  const features = [
    {
      icon: Clock,
      title: 'Real-Time Tracking',
      description: 'Watch the progress of your garments, from fabric selection to final stitch.',
    },
    {
      icon: Ruler,
      title: 'Measurement Control',
      description: 'Review, manage, and secure your personal measurement data for consistently accurate fittings.',
    },
    {
      icon: Bell,
      title: 'Direct Updates',
      description: 'Receive production status updates directly from your tailor, building transparent trust.',
    },
  ];

  return (
    <section className="bg-brand-blue py-16 lg:py-20 relative overflow-hidden">
      {/* Decorative Yellow Circles */}
      <div className="absolute left-[-53px] top-[-38px] w-[247px] h-[309px] hidden lg:block">
        <div className="w-full h-full bg-brand-yellow rounded-full opacity-30" style={{ borderRadius: '50%' }}></div>
      </div>
      <div className="absolute right-[-53px] bottom-[-38px] w-[249px] h-[178px] hidden lg:block">
        <div className="w-full h-full bg-brand-yellow rounded-full opacity-30" style={{ borderRadius: '50%' }}></div>
      </div>

      <div className="max-w-container-lg mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-manrope text-body-small text-white mb-4"
          >
            Securely Track Your Craftsmanship
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="font-opensans text-display-xl text-white font-bold mb-6"
          >
            Customers
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="font-manrope text-body-medium text-white max-w-[547px] mx-auto"
          >
            Master Ji makes it simple to stay connected with your tailor throughout the entire process. No hassle—just one free place to track and manage everything.
          </motion.p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="text-center"
              >
                {/* Icon Circle */}
                <div className="bg-brand-cream w-[172px] h-[172px] rounded-[86px] mx-auto mb-6 flex items-center justify-center">
                  <Icon className="w-16 h-16 text-brand-blue" />
                </div>

                {/* Feature Title */}
                <h3 className="font-opensans text-heading-2 text-white font-bold mb-4">
                  {feature.title}
                </h3>

                {/* Description */}
                <p className="font-manrope text-body-medium text-white max-w-[304px] mx-auto">
                  {feature.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CustomersSection;

